import { Component } from '@angular/core';
//import { AmazingTimePickerService } from 'amazing-time-picker'; // this line you need
declare var $: any;

@Component({
  selector: 'mytime-picker',
  templateUrl: './mytime-picker.component.html'
})
//var declare amazingTimePicker ;

export class MyTimePicker {
  
  constructor( //private atp: AmazingTimePickerService, // this line you need
             ) { }

//   open() {
//     const amazingTimePicker = this.atp.open();
//     amazingTimePicker.afterClose().subscribe(time => {
//       console.log(time);
//     });
//   }
ngAfterViewInit(){
  $('.clockpicker').clockpicker();

}
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/mytimePicker/mytime-picker.component.ts